<!-- <div class="m-portlet--tab">
	<div class="m-portlet__head">
		<div class="m-portlet__head-caption">
			<div class="">
				<div class="m-portlet__head-text title-style">
					Search Results
				</div>
			</div>
		</div>
	</div>
</div> -->
<div class="m-subheader" appunwraptag="">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">
                ToT/ToA Dashboard
            </h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a class="m-nav__link m-nav__link--icon">
                        <i class="la la-briefcase"></i>
                    </a>
                </li>
                <li class="m-nav__separator">
                    -
                </li>
                <li class="m-nav__item">
                    <span class="m-nav__link-text">
                        Search & Apply
                    </span>
                </li>
                <li class="m-nav__separator">
                    -
                </li>
                <li class="m-nav__item">
                    <span class="m-nav__link-text">
                        Search Batches
                    </span>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="m-content">
    <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-text title-style">
                    <label class="col-md-5 col-lg-5 col-sm-3 notranslate">Search & Training Requests</label>
                    <button class="btn btn-secondary pull-right" (click)="goBack()">
                        Back
                    </button>
                    <button class="btn btn-secondary pull-right btn-alignment notranslate" routerLink="./../view-batches" style="margin:0px 10px">
                        View My Batches
                    </button>
                    <button class="btn btn-secondary pull-right btn-alignment notranslate" *ngIf="showPreferenceButton" data-target="#preferences_modal" data-toggle="modal">
                        Add Training Requests
                    </button>
                </div>
            </div>
        </div>
        <div class="m-portlet__body">
            <ul class="nav nav-pills" role="tablist">
                <li class="nav-item dropdown">
                    <a class="nav-link active" #preferences data-toggle="tab" href="#m_tab_preferences" (click)="setData('applicant')">
                        Training Requests
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" #batchDetails data-toggle="tab" href="#m_tab_search_batches" (click)="hideButton('batches')">
                        Search Batches
                    </a>
                </li>
                <hr>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="m_tab_preferences" role="tabpanel">
                    <div class="m-portlet__body">
                        <form [formGroup]="trFilterForm">
                            <!-- Filters : begins -->
                            <div class="row margin-bottm">

                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="State">State</label>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="state" name="option" (change)="_applicantDataService.getDistrictsTR();getSelectedData()">
                                        <option value=null selected disabled>Select State</option>
                                        <option *ngFor="let state of _applicantDataService.states" [ngValue]="state">
                                            {{state.name}}
                                        </option>
                                    </select>

                                </div>
                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="District">District</label>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="district" (change)="_applicantDataService.getSubDistrictsTR();getSelectedData()" name="option">
                                        <option value=null selected disabled>Select District</option>
                                        <option *ngFor="let district of _applicantDataService.districts"
                                            [ngValue]="district">
                                            {{district.name}}</option>
                                    </select>

                                </div>
                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="District">Sub-District</label>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="subDistrict" name="option">
                                        <option value=null selected disabled>Select Sub-District</option>
                                        <option *ngFor="let subDistrict of _applicantDataService.subDistricts"
                                            [ngValue]="subDistrict">
                                            {{subDistrict.name}}</option>
                                    </select>

                                </div>
                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="Sector">Sector</label>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" name="option" formControlName="sector" (change)="getSelectedData(); _applicantDataService.getJobRolesTR();">
                                        <option value=null selected disabled>Select Sector</option>
                                        <option *ngFor="let sector of _applicantDataService.sectors" [ngValue]="sector">
                                            {{sector.sector}}</option>
                                    </select>

                                </div>
                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="Sector">Applicant Type </label>
                                    </div>
                                    <ng-container *ngIf="this.userRole ==='Trainer'">
                                        <select class="notranslate form-control m-input m-input--square" name="option" formControlName="applicantType" (change)="getSelectedData(); _applicantDataService.getJobRolesTR();">
                                            <option value=null selected disabled>Select Applicant Type </option>
                                            <option [ngValue]="status.value" *ngFor="let status of trApplicantType">
                                                {{status.name}} </option>
                                            <!-- <option *ngIf='this.userRole ==="Trainer"' [ngValue]="status.value" *ngFor="let status of trApplicantType_assessor"> {{status.name}} </option>                              -->
                                        </select>
                                    </ng-container>
                                    <ng-container *ngIf="this.userRole ==='Assessor'">
                                        <select class="notranslate form-control m-input m-input--square" name="option" formControlName="applicantType" (change)="getSelectedData(); _applicantDataService.getJobRolesTR();">
                                            <option value=null selected disabled>Select Applicant Type </option>
                                            <option [ngValue]="status.value" *ngFor="let status of arApplicantType">
                                                {{status.name}} </option>
                                        </select>
                                    </ng-container>
                                </div>
                                <div class="col-2 col-sm-2 padding-right margin-top">
                                    <div class="col-sm-12">
                                        <label for="Sector">Job Role Name </label>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="jobRole" name="option">
                                        <option value=null selected disabled>Select Job Role</option>
                                        <option *ngFor="let jobRole of _applicantDataService.jobRoles"
                                            [ngValue]="jobRole">
                                            {{jobRole.jobRole}} ({{jobRole.qpCode}}) - v{{jobRole.version}}</option>
                                    </select>

                                </div>
                                <div class="col-2 col-sm-2 padding-right" style="margin-top: 10px;">
                                    <div class="col-sm-12">
                                        <label for="Sector">Status </label>
                                    </div>
                                    <select class="notranslate form-control" formControlName="status">
                                        <option value=null selected disabled>Select Status</option>
                                        <option [ngValue]="status.value" *ngFor="let status of requestStatus">
                                            {{status.name}} </option>
                                    </select>
                                </div>
                                <div class="col-sm-2" style="margin-top: 10px;">
                                    <label>
                                        Requested On
                                    </label>
                                    <input type="text" class="form-control m-input" (focusout)="startDateTR($event)" readonly="true" placeholder="From Date" [id]="fromDate" formControlName="startDate">
                                </div>
                                <div class="m-demo-icon__preview">
                                    <i class="fa fa-arrow-right arrow-color"></i>
                                </div>
                                <div class="col-sm-2" style="margin-top:15px">
                                    <label> </label>
                                    <input type="text" class="notranslate form-control m-input" (focusout)="endDateTR($event)" readonly="true" placeholder="To Date" [id]="toDate" formControlName="endDate">
                                </div>
                                <div class="col-sm-2" style="margin-top:34px;">
                                    <div>
                                        <label> </label>
                                        <button type="button" class="btn btn-primary" (click)="searchFilter()">
                                            Apply
                                        </button>
                                        <button type="button" class="btn btn-secondary color-info" (click)="resetTrForm()">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <br>
                        <!-- End -->
                        <table class="table table-striped m-table">
                            <thead class="m-datatable__head">
                                <tr class="m-datatable__row">
                                    <th>S.No.</th>
                                    <th>Applicant Type</th>
                                    <th>
                                        <b>Job Role Name (QP Code)</b>
                                    </th>
                                    <th>
                                        <b>Sector</b>
                                    </th>
                                    <th>
                                        <b>State</b>
                                    </th>
                                    <th>
                                        <b>District</b>
                                    </th>
                                    <th>
                                        <b>Sub-District</b>
                                    </th>
                                    <th>
                                        <b>Status</b>
                                    </th>
                                    <th>
                                        <b>Action</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="notranslate" *ngIf="trainerReqData && trainerReqData.length !== 0; else showError">
                                <tr *ngFor="let trData of trainerReqData; let i = index;">
                                    <th scope="row">{{i+1}}.</th>
                                    <td>{{ trData.applicantType | titlecase }}</td>
                                    <td>{{trData.jobRole.jobName}} ({{trData.jobRole.qpCode}}) - v{{trData.jobRole.version}}
                                    </td>
                                    <td>{{trData.sector.sector}}</td>
                                    <td>{{trData.state.name}}</td>
                                    <td>{{trData.district.name ? trData.district.name : "NA"}}</td>
                                    <td>{{trData.subDistrict.name ? trData.subDistrict.name : "NA" }}</td>
                                    <td> <span class="requestColor" [style.color]="requestStatusColor[trData.status]">{{showRequestStatus(trData.status)}}
                                        </span></td>
                                    <td>
                                        <span style="overflow: visible; width: 100px;">
                                            <div class="dropdown">
                                                <a href="javascript:;"
                                                    class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                                    data-toggle="dropdown">
                                                    <i class="la la-ellipsis-h"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <a class="dropdown-item"
                                                        *ngIf="trData?.status === 'AWAITING_BATCH_ENROLLMENT'"
                                                        (click)="searchPreferences(trData)">
                                                        Search Batches
                                                    </a>
                                                    <a class="dropdown-item" data-toggle="modal"
                                                        *ngIf="trData.status !== 'REMOVED_BY_APPLICANT'
                                                    && trData.status !== 'FULLFILLED_BY_BATCH' && trData.status !== 'REJECTED' && trData.status !== 'FULLFILLED_BY_CERTIFICATE'"
                                                        (click)="removePreference(trData)">
                                                        Remove Training Requests
                                                    </a>
                                                    <a class="dropdown-item" data-toggle="modal"
                                                        data-target="#review_modal" (click)="showComments(trData)"
                                                        *ngIf="(trData.status ==='APPROVED') || (trData.status ==='AWAITING_BATCH_ENROLLMENT') || (trData.status ==='REJECTED')|| (trData.status ==='REMOVED_BY_APPLICANT')">
                                                        View Comments
                                                    </a>
                                                    <a class="dropdown-item"
                                                        *ngIf="trData.status === 'FULLFILLED_BY_CERTIFICATE'">
                                                        <span class="m-nav__link-text hover-font hover-padding"
                                                            (click)="getApplicantCertificateDetails(trData)">
                                                            View Certificate
                                                        </span>
                                        </a>
                                        <a class="dropdown-item" *ngIf="(trData.status === 'ENROLLED_TO_BATCH') || (trData.status === 'FULLFILLED_BY_BATCH')">
                                            <span class="m-nav__link-text hover-font hover-padding" (click)="navigateTo(trData)">
                                                            View Batch Details
                                                        </span>
                                        </a>
                    </div>
                </div>
                </span>
                </td>
                </tr>
                </tbody>
                <ng-template #showError>
                    <p>No Data Found.</p>
                </ng-template>
                </table>
                <!-- <div *ngIf="res.length > 10">
                            <app-pagination [count]="length" (pageNumber)="setPageNumber($event)" [defaultRecordsPerPage]="itemsPerPage"
                              (recordsPerPage)="setRecordsPerPage($event)"></app-pagination>
                          </div> -->

                <!-- <app-pagination [count]=length (pageNumber)="setPageNumber($event)" (recordsPerPage)="setRecordsPerPage($event)"></app-pagination> -->
                <div>
                    <app-search-result-for-applicant (sendData)="showViewlinkRequestModel($event)" [searchedData]="searchResult"></app-search-result-for-applicant>
                </div>
            </div>
        </div>
        <div class="tab-pane" id="m_tab_search_batches" role="tabpanel">
            <app-search-applicant #batchDetails [role]="userInfo.role"></app-search-applicant>
        </div>
    </div>
</div>
</div>
</div>



<div class="modal fade" id="preferences_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title notranslate" id="exampleModalLabel">
                    Add Training Requests
                </h5>
                <button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="m-section">
                    <div class="m-section__content">
                        <form class="m-form" [formGroup]="searchBatchesForm">

                            <label class="sub-head-color"> Applicant Type </label>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left:127px;">
                                        Select Type
                                        <span style="color: red">* </span>:
                                    </label>
                                </div>
                                <div class="notranslate col-lg-8 col-md-8 col-sm-8">
                                    <ng-container *ngIf="this.userRole ==='Trainer'">
                                        <div class="row">
                                            <div class="col-3 m-radio-inline" style="margin-left: 12px;">
                                                <label class="m-radio">
                                                    <input type="radio" name="applicantType" value="trainer"
                                                        formControlName="applicantType">
                                                    Trainer
                                                    <span></span>
                                                </label>
                                            </div>
                                            <div class="col-4" style="margin-top:4px;">
                                                <label class="m-radio">
                                                    <input type="radio" name="applicantType" value="masterTrainer"
                                                        formControlName="applicantType">
                                                    Master Trainer
                                                    <span></span>
                                                </label>
                                            </div>
                                            <div class="col-4"></div>
                                            <app-form-control-messages [control]="searchBatchesForm.get('applicantType')" [name]="'Applicant Type'"></app-form-control-messages>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="this.userRole ==='Assessor'">
                                        <div class="row">
                                            <div class="col-3 m-radio-inline" style="margin-left: 12px;">
                                                <label class="m-radio">
                                                    <input type="radio" name="request" value="assessor"
                                                        formControlName="applicantType">
                                                    Assessor
                                                    <span></span>
                                                </label>
                                            </div>
                                            <div class="col-4" style="margin-top:4px;">
                                                <label class="m-radio">
                                                    <input type="radio" name="request" value="masterAssessor"
                                                        formControlName="applicantType">
                                                    Master Assessor
                                                    <span></span>
                                                </label>
                                            </div>
                                            <div class="col-4"></div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <label class="sub-head-color">Preferred Job Role</label>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left: 123px;">
                                        Select Sector
                                        <span style="color: red">* </span>:
                                    </label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
                                            <g>
                                                <path
                                                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                </path>
                                            </g>
                                        </svg>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" name="option" formControlName="sector" (change)="_applicantDataService.getJobRoles()">
                                        <option value="" selected disabled>Select Sector</option>
                                        <option *ngFor="let sector of _applicantDataService.sectors" [ngValue]="sector">
                                            {{sector.sector}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left: 112px;">
                                        Select Job Role
                                        <span style="color: red">* </span>:
                                    </label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
                                            <g>
                                                <path
                                                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                </path>
                                            </g>
                                        </svg>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="jobRole" name="option">
                                        <option value="" selected disabled>Select Job Role</option>
                                        <option *ngFor="let jobRole of _applicantDataService.jobRoles"
                                            [ngValue]="jobRole">{{jobRole.jobRole}} ({{jobRole.qpCode}}) -
                                            v{{jobRole.version}}</option>
                                    </select>
                                </div>
                            </div>
                            <!-- <hr> -->
                            <label class="form-group m-form__group sub-head-color">Preferred Location</label>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left: 177px;">
                                        State
                                        <span style="color: red">*</span> :
                                    </label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
                                            <g>
                                                <path
                                                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                </path>
                                            </g>
                                        </svg>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="state" name="option" (change)="_applicantDataService.getDistricts()">
                                        <option value="" selected disabled>Select State</option>
                                        <option *ngFor="let state of _applicantDataService.states" [ngValue]="state">
                                            {{state.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left:170px;">
                                        District:
                                        <!-- <span style="color: red">*</span>: -->
                                    </label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
                                            <g>
                                                <path
                                                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                </path>
                                            </g>
                                        </svg>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="district" (change)="_applicantDataService.getSubDistricts()" name="option" placeholder="Select District">
                                        <option value="" selected disabled>Select District</option>
                                        <option *ngFor="let district of _applicantDataService.districts"
                                            [ngValue]="district">{{district.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-form-label">
                                    <label style="margin-left:140px;">
                                        Sub-District:
                                        <!-- <span style="color: red">*</span>: -->
                                    </label>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
                                            <g>
                                                <path
                                                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
                                                </path>
                                            </g>
                                        </svg>
                                    </div>
                                    <select class="notranslate form-control m-input m-input--square" formControlName="subDistrict" name="option" placeholder="Select Sub-District">
                                        <option value="" selected disabled>Select Sub-District</option>
                                        <option *ngFor="let subDistrict of _applicantDataService.subDistricts"
                                            [ngValue]="subDistrict">{{subDistrict.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="addJobRole();setData()" [disabled]="!searchBatchesForm.valid">
                    Add Training Request
                </button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="resetFormData()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Model --- Remove Training Request -->
<div class="modal fade" id="remove_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel" style="font-size : 20px!important">
                    Remove Training Request
                </h4>
                <button type="button" class="close" (click)="closeRequestModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <form class="m-form align" [formGroup]="actionTakenForm">
                    <label class="col-12"><b>Remarks</b></label>
                    <div class="col-12">
                        <div class="form-group">
                            <textarea class="form-control m-input m-input--air" rows="8" placeholder="Enter Remarks/ Reason for Rejection" formControlName="comment"></textarea>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeRequestModal()">
                    Close
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="deleteApplicantPref()">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>
<!--Model End -->

<div class="modal fade" id="review_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    <b>View Comments</b>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeModel>
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body" style="padding-left: 5rem" *ngIf="preference?.status === 'REJECTED' || preference?.status === 'AWAITING_BATCH_ENROLLMENT'">
                <div class="m-form__group form-group row" *ngIf="preference?.status === 'REJECTED'">
                    <label class="col-4">
                        <b>Reason By SSC :</b>
                    </label>
                    <div class="col-8">
                        {{preference && preference.commentsBySSC ? preference.commentsBySSC.reason : 'N/A'}}
                    </div>
                </div>
                <div class="m-form__group form-group row">
                    <label class="col-4">
                        <b>Comments By SSC :</b>
                    </label>
                    <div class="col-8">
                        {{ preference && preference.commentsBySSC && preference.commentsBySSC.comment ? preference.commentsBySSC.comment : 'N/A'}}
                    </div>
                </div>
            </div>
            <div class="modal-body" style="padding-left: 5rem" *ngIf="preference?.status === 'REMOVED_BY_APPLICANT'">
                <div class="m-form__group form-group row">
                    <label class="col-4">
                        <b>Comments By Applicant :</b>
                    </label>
                    <div class="col-8">
                        {{ preference && preference.reasonForRemoval && preference.reasonForRemoval.reason ? preference.reasonForRemoval.reason : 'N/A'}}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-cancel" data-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade align-modal show" id="linkTrainingRequests" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content set-width">
            <div class="modal-header">
                <h1 class="modal-title">
                    <b>View and Link Training Request(s)</b>
                </h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span id="closeModal" data-dismiss="modal" aria-hidden="true">×</span>
				</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <span class="col-4">
						<label><b>Batch ID:</b></label>
						<span>{{appliedBatch?.batchId}}</span>
                    </span>
                    <span class="col-8">
						<label><b>Batch Name:</b></label>
						<span>{{appliedBatch?.batchName}}</span>
                    </span>
                </div>
                <div class="row">
                    <span class="col-4">
						<label><b>Batch Type:</b></label>
						<span>{{appliedBatch?.type}}</span>
                    </span>
                    <span class="col-4">
						<label><b>Batch Date:</b></label>
						<span>{{appliedBatch?.batchStartDate | date: 'dd/MM/yyyy'}} to
							{{appliedBatch?.batchEndDate | date: 'dd/MM/yyyy'}}</span>
                    </span>
                    <span class="col-4">
						<label><b>Batch Fee:</b></label>
						<span>{{appliedBatch?.batchFee?.totalFees}}</span>
                    </span>
                </div>
                <hr>
                <div class="row">
                    <span type="text" class="btn btn-link placeholder-color">
						Selected Request
					</span>
                    <button type="button" class="btn btn-secondary" (click)="resetAllCandidates()" style="margin:0 10px;">
						De-Select All
					</button>
                    <button type="button" class="btn btn-primary" (click)="linkTrainingRequest()">
						Link Request(s)
					</button>
                </div>
                <hr>
                <div class="col-12">
                    <table class="table">
                        <thead>
                            <td>
                                <label class="m-checkbox m-checkbox--solid m-checkbox--state-success">
									<input type="checkbox" [(ngModel)]="selectStatus" name="Checkbox"
										(click)="selectAll()">
									<span></span>
								</label>
                            </td>
                            <td>Job Role Name(QP Code)</td>
                            <td>Sector</td>
                            <td>State</td>
                            <td>District</td>
                            <td>Requested On</td>
                        </thead>
                        <tbody class="notranslate" *ngFor="let request of trainingRequestLists; let i = index">
                            <tr>
                                <td>
                                    <label class="m-checkbox m-checkbox--solid m-checkbox--state-success">
										<input type="checkbox" [(ngModel)]="request.isSelected" name="Check"
											(click)=selectOne(i)>
										<span></span>
									</label>
                                </td>
                                <td>{{request?.jobRole?.jobName}} ({{request?.jobRole?.qpCode}})</td>
                                <td>{{request?.sector?.sector}}</td>
                                <td>{{request?.state?.name}}</td>
                                <td>{{request?.district?.name}}</td>
                                <td>{{request?.requestedOn | date: 'dd/MM/yyy'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <app-pagination [count]="count" (pageNumber)="changePageNumber($event)"
						[defaultRecordsPerPage]="perPage" (recordsPerPage)="changeRecordsPerPage($event)">
					</app-pagination> -->
                <hr>
                <div class="pull-right">
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button class="btn btn-primary" (click)="linkTrainingRequest()">Link Request(s)</button>
                </div>
            </div>
        </div>
    </div>
</div>